export default [
  {
    path: '/activity-20250702-main',
    component: () => import('./Main.vue'),
    meta: { id: 138, expire: '2025-07-02T23:59:59.000+08:00', title: '声动心弦·HiFun甜御争锋赛' },
  },
  {
    path: '/activity-20250702-rule',
    component: () => import('./Rule.vue'),
    meta: { id: 139, expire: '2025-07-02T23:59:59.000+08:00', title: '声动心弦·HiFun甜御争锋赛' },
  },
]
